import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { Entity } from '../types/entity';
import queryClient from '../query-client';

export type UpdateFYIConfigRequest = {
    accessKeyId?: string;
    accessKeySecret?: string;
    cabinet?: { id: number; name: string };
};

async function updateFYIConfig(req: UpdateFYIConfigRequest): Promise<{ entity: Entity }> {
    const { data } = await api.patch('/fyi-docs/configuration', req);
    return data;
}

export function useUpdateFYIConfig(): UseMutationResult<{ entity: Entity }, AxiosError, UpdateFYIConfigRequest, unknown> {
    return useMutation(updateFYIConfig, {
        onSettled: () => {
            queryClient.invalidateQueries(['fyi', 'configuration']);
            queryClient.invalidateQueries(['firm']);
        },
    });
}
